import Events from "../Utils/EventLite";
var pages = [];

export default class Page {
    constructor(template, model, pageId = "page"+pages.length+1) {
        this.id = pageId;
        this.model = model;
        this.element = document.createElement("div");
        this.element.id = pageId;
        this.element.classList.add("page");
        this.element.classList.add("hide");
        this.element.classList.add("fullscreen");
        this.template = template(model);
        this.element.innerHTML = this.template;
        this.buttons = [];
        pages[pageId] = this;
        this.handleButtonProxy = (e)=>this.handleButton(e);
    }
    static getPages() {
        return pages;
    }
    static getPage(id){
        return pages[id];
    }
    init(resolve, reject) {
        this.bindEvents();
        this.element.classList.add("show");
        this.element.classList.remove("hide");
        if(resolve != undefined) {
        resolve()
        }
    }
    close(resolve, reject) {
        this.unbindEvents();
        this.element.classList.add("hide");
        this.element.classList.remove("show");
        resolve()
    }
    handleButton(e) {
        if(this.model.events[e.currentTarget.getAttribute("data-action")]) {
            Events.trigger(e.currentTarget.getAttribute("data-action"), this.model);
        }
    }
    bindEvents() {
        this.buttons = this.element.getElementsByTagName("button");
        for(var i = 0; i < this.buttons.length; i++) {
            var button = this.buttons[i];
            button.addEventListener("click", this.handleButtonProxy)
        }
    }
    unbindEvents() {
        for(var i = 0; i < this.buttons.length; i++) {
            var button = this.buttons[i];
            button.removeEventListener("click", this.handleButtonProxy)
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/Page.js